var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "field",
      class: [
        {
          "has-error": _vm.v && _vm.v.$anyError,
          "is-required": _vm.isRequired,
        },
        _vm.classes,
        _vm.name ? _vm.name : "",
      ],
      attrs: { disabled: _vm.iniDisabled },
    },
    [
      _vm.label
        ? _c("label", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "field has-addons": !!this.$slots.append || !!this.$slots.prepend,
          },
        },
        [
          !!this.$slots.prepend
            ? _c("div", { staticClass: "control" }, [_vm._t("prepend")], 2)
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "control is-expanded" },
            [
              _vm.iniDisabled
                ? [
                    _vm.dateFromNow && _vm.type != "HOURS"
                      ? _c("div", { staticClass: "control" }, [
                          _c(
                            "div",
                            { staticClass: "input disabled" },
                            [
                              _vm.selected
                                ? _c("dateFromNow", {
                                    attrs: {
                                      iniDate: _vm.selected,
                                      iniDateFormat: _vm.dateFormat,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ])
                      : _c("span", { staticClass: "input disabled" }, [
                          _vm._v(_vm._s(_vm.readOnlyValue)),
                        ]),
                  ]
                : [
                    _vm.type == "DATE"
                      ? [
                          _c("b-datepicker", {
                            attrs: {
                              placeholder: _vm.placeholder
                                ? _vm.placeholder
                                : _vm.$t("clickToSelect"),
                              disabled: _vm.iniDisabled,
                              "date-formatter": _vm.formatDate,
                              icon: "calendar-alt",
                              "append-to-body": _vm.appendToBody,
                              position: _vm.position,
                              "min-date": _vm.minDate,
                              editable: _vm.isEditable,
                              "first-day-of-week": 1,
                              focusedDate: _vm.focusedDate,
                            },
                            on: { input: _vm.onChange },
                            model: {
                              value: _vm.selectedAsDate,
                              callback: function ($$v) {
                                _vm.selectedAsDate = $$v
                              },
                              expression: "selectedAsDate",
                            },
                          }),
                        ]
                      : _vm.type == "DATETIME"
                      ? [
                          _c("b-datetimepicker", {
                            attrs: {
                              placeholder: _vm.placeholder
                                ? _vm.placeholder
                                : _vm.$t("clickToSelect"),
                              disabled: _vm.iniDisabled,
                              "datetime-formatter": _vm.formatDateTime,
                              icon: "calendar-day",
                              "append-to-body": _vm.appendToBody,
                              position: _vm.position,
                              "min-date": _vm.minDate,
                              editable: _vm.isEditable,
                              "first-day-of-week": 1,
                              focusedDate: _vm.focusedDate,
                            },
                            on: { input: _vm.onChange },
                            model: {
                              value: _vm.selectedAsDate,
                              callback: function ($$v) {
                                _vm.selectedAsDate = $$v
                              },
                              expression: "selectedAsDate",
                            },
                          }),
                        ]
                      : _vm.type == "TIME"
                      ? [
                          _c(
                            "b-field",
                            [
                              _c("b-input", {
                                attrs: { disabled: _vm.iniDisabled },
                                model: {
                                  value: _vm.hours,
                                  callback: function ($$v) {
                                    _vm.hours = $$v
                                  },
                                  expression: "hours",
                                },
                              }),
                              _vm._v(" "),
                              _c("p", { staticClass: "control" }, [
                                _c(
                                  "span",
                                  { staticClass: "button is-static" },
                                  [_vm._v("h")]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-input", {
                                staticClass: "minutes",
                                attrs: { disabled: _vm.iniDisabled },
                                model: {
                                  value: _vm.minutes,
                                  callback: function ($$v) {
                                    _vm.minutes = $$v
                                  },
                                  expression: "minutes",
                                },
                              }),
                              _vm._v(" "),
                              _c("p", { staticClass: "control" }, [
                                _c(
                                  "span",
                                  { staticClass: "button is-static" },
                                  [_vm._v("min")]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]
                      : _vm.type == "HOURS"
                      ? [
                          _c(
                            "b-field",
                            [
                              _c("b-input", {
                                attrs: {
                                  disabled: _vm.iniDisabled,
                                  type: "time",
                                  step: _vm.step,
                                },
                                on: { input: _vm.onChange },
                                model: {
                                  value: _vm.hoursValue,
                                  callback: function ($$v) {
                                    _vm.hoursValue = $$v
                                  },
                                  expression: "hoursValue",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          !!this.$slots.append
            ? _c("div", { staticClass: "control" }, [_vm._t("append")], 2)
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.v && _vm.v.$anyError
        ? _c("span", { staticClass: "help is-danger" }, [_vm._t("onError")], 2)
        : _vm._e(),
      _vm._v(" "),
      !!this.$slots.help
        ? _c("span", { staticClass: "help info" }, [_vm._t("help")], 2)
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }